/* eslint-disable react-hooks/exhaustive-deps */
/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-07-06 14:28:53
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withI18n } from '@shopify/react-i18n';
import { Card, Button } from '@shopify/polaris';
import PackageCard from 'src/components/views/subscription-v3/package/package-card';
import { PACKAGES } from 'src/constants/subscription';
import history from 'src/routes/history';
import { routes } from 'src/routes';
import { isFreemiumPlan } from 'src/helpers/subscription-v4-helper';
import { showChatbox } from 'src/integrations/chatbox';

//--------------------------
// Render packages plan/ package info in subscription page
const PlanPackage = props => {
  const [packageSelected, setPackageSelected] = useState();
  // props
  const {
    i18n,
    invoice,
    gettingPackage,
    gettingInvoice,
    packagePlans = {},
    currentTotalProducts = 0,
    tenantApp
  } = props;

  const goToComparison = () => {
    history.push(routes.subscription.comparison(packageSelected));
  };

  const handleChange = e => {
    setPackageSelected(e);
  };

  const openChatBox = () => {
    showChatbox();
  };

  const isFreemium = isFreemiumPlan(tenantApp);

  return (
    <Card
      title={
        <div className="cardTitle">
          <span className="Polaris-Heading">
            {i18n.translate('AdminHTML.SubscriptionV3.Subscription.packages')}
          </span>
        </div>
      }>
      <Card.Section>
        <div className="packages">
          <div>
            <div>
              {PACKAGES.map((e, index) => (
                <PackageCard
                  packageInfo={e}
                  key={index}
                  index={index}
                  history={history}
                  packagePlans={packagePlans[e.name]}
                  allPackagePlans={packagePlans}
                  invoice={invoice}
                  packageSelected={packageSelected}
                  setPackageSelected={handleChange}
                  currentTotalProducts={currentTotalProducts}
                  gettingPackage={gettingPackage}
                  gettingInvoice={gettingInvoice}
                />
              ))}
            </div>
            <div className="compare-package">
              <div>
                <p>
                  {i18n.translate('AdminHTML.SubscriptionV3.Subscription.comparePackage_Text01')}
                </p>
                <p>
                  {i18n.translate('AdminHTML.SubscriptionV3.Subscription.comparePackage_Text02')}
                </p>
              </div>
              <Button onClick={() => goToComparison()}>
                {i18n.translate('AdminHTML.SubscriptionV3.Subscription.comparePackage')}
              </Button>
            </div>
            <p>
              {isFreemium
                ? i18n.translate('AdminHTML.SubscriptionV3.Packages.footerCard', {
                    t1: (
                      <b style={{ marginLeft: 4 }}>
                        {i18n.translate('AdminHTML.SubscriptionV3.Packages.footer_t1')}
                      </b>
                    )
                  })
                : i18n.translate('AdminHTML.SubscriptionV3.Packages.footerCardNew', {
                    t: (
                      <span
                        style={{ cursor: 'pointer', textDecoration: 'underline', marginRight: 4 }}
                        onClick={openChatBox}>
                        {i18n.translate('AdminHTML.SubscriptionV3.Packages.footerCardNew_t')}
                      </span>
                    )
                  })}
            </p>
          </div>
        </div>
      </Card.Section>
    </Card>
  );
};

const mapStateToProps = (state, props) => {
  const tenantApp = _.get(state.oauth, 'tenantApp', {});

  return {
    tenantApp
  };
};

export default withI18n()(connect(mapStateToProps)(PlanPackage));
